import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { Button } from '@/components/ui/button';
import { Unit } from '@/types/unit';

type SelectedUnitsActionBarProps = {
  selectedUnits: Unit[];
  hasUnitsWithDevices?: boolean;
  sendAnnouncementVisible?: boolean;
  sendResponseNotificationVisible?: boolean;
  openSendAnnouncement?: () => void;
  openSendResponseNotification?: () => void;
};

export const SelectedUnitsActionBar: FC<SelectedUnitsActionBarProps> = ({
  selectedUnits,
  hasUnitsWithDevices = true,
  sendAnnouncementVisible = true,
  sendResponseNotificationVisible = true,
  openSendAnnouncement,
  openSendResponseNotification,
}) => {
  if (selectedUnits.length === 0) {
    return null;
  }

  const disabledTooltip =
    'No devices added to the selected units. Please add a device to send';

  return (
    <div className="mt-4 mb-4 flex flex-row items-center justify-between rounded-md bg-gray-800 p-4 text-white">
      <div>
        <span className="text-sm font-medium">
          {selectedUnits.length} unit{selectedUnits.length === 1 ? '' : 's'}{' '}
          selected
        </span>
      </div>
      <div className="flex flex-row gap-2">
        {sendAnnouncementVisible && selectedUnits.length > 0 && (
          <>
            <Tooltip anchorSelect="#unitAnnouncementTooltip">
              {hasUnitsWithDevices
                ? 'Send an announcement to the selected units'
                : `${disabledTooltip} announcements.`}
            </Tooltip>
            <a id="unitAnnouncementTooltip">
              <Button
                className="ml-auto"
                disabled={!hasUnitsWithDevices}
                onClick={openSendAnnouncement}
                variant="secondary"
              >
                Send announcement
              </Button>
            </a>
          </>
        )}
        {sendResponseNotificationVisible && selectedUnits.length > 0 && (
          <>
            <Tooltip anchorSelect="#unitResponseNotificationTooltip">
              {hasUnitsWithDevices
                ? 'Send a response notification to the selected units'
                : `${disabledTooltip} notifications.`}
            </Tooltip>
            <a id="unitResponseNotificationTooltip">
              <Button
                className="ml-auto"
                disabled={!hasUnitsWithDevices}
                onClick={openSendResponseNotification}
                variant="secondary"
              >
                Send response notification
              </Button>
            </a>
          </>
        )}
      </div>
    </div>
  );
};
